import { useEffect, useRef, useState } from 'react';

interface GeolocationPosition {
	loading: boolean;
	latitude: number | null;
	longitude: number | null;
	timestamp: number | null;
	error: GeolocationPositionError | null;
}

export function useGeolocation(options = { enableHighAccuracy: true, timeout: 10000, maximumAge: 0 }) {
	const [state, setState] = useState<GeolocationPosition>({
		loading: true,
		latitude: null,
		longitude: null,
		timestamp: null,
		error: null,
	});

	const optionsRef = useRef(options);

	useEffect(() => {
		const onEvent = ({ coords, timestamp }) => {
			setState({
				loading: false,
				timestamp,
				latitude: coords.latitude,
				longitude: coords.longitude,
				error: null,
			});
		};

		const onEventError = (error: GeolocationPositionError) => {
			setState((s) => ({
				...s,
				loading: false,
				error,
			}));
		};

		navigator.geolocation?.getCurrentPosition(onEvent, onEventError, optionsRef.current);

		const watchId = navigator.geolocation?.watchPosition(onEvent, onEventError, optionsRef.current);

		return () => {
			navigator.geolocation?.clearWatch(watchId);
		};
	}, []);

	return state;
}
